const googleOAuthClientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || '';
const hasGoogleOAuthClientId = Boolean(
    googleOAuthClientId &&
    !googleOAuthClientId.includes('YOUR_GOOGLE_WEB_CLIENT_ID')
);

const config = {
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL || '',
    GOOGLE_OAUTH_CLIENT_ID: googleOAuthClientId,
    HAS_GOOGLE_OAUTH_CLIENT_ID: hasGoogleOAuthClientId,
    FRONTEND_ORIGIN: process.env.REACT_APP_FRONTEND_ORIGIN || '',
};

export default config;
